import * as coreClient from "@azure/core-client";
import * as Parameters from "./models/parameters";
import * as Mappers from "./models/mappers";
import {
  HostOptions,
  OrderAPIOptionalParams,
  GetOrderByOrderNumberOptionalParams,
  GetOrderByOrderNumberResponse
} from "./models";

export class OrderAPI extends coreClient.ServiceClient {
  $host: HostOptions;

  /**
   * Initializes a new instance of the OrderAPI class.
   * @param options The parameter options
   */
  constructor(options?: OrderAPIOptionalParams) {
    // Initializing default values for options
    if (!options) {
      options = {};
    }
    const defaults: OrderAPIOptionalParams = {
      requestContentType: "application/json; charset=utf-8"
    };

    const packageDetails = `azsdk-js-orderAPI/1.0.0-beta.1`;
    const userAgentPrefix =
      options.userAgentOptions && options.userAgentOptions.userAgentPrefix
        ? `${options.userAgentOptions.userAgentPrefix} ${packageDetails}`
        : `${packageDetails}`;

    const optionsWithDefaults = {
      ...defaults,
      ...options,
      userAgentOptions: {
        userAgentPrefix
      },
      baseUri:
        options.endpoint ??
        options.baseUri ??
        "https://nxbus.api.nationalexpress.com"
    };
    super(optionsWithDefaults);

    // Assigning values to Constant parameters
    this.$host = options.$host || "https://nxbus.api.nationalexpress.com";
  }

  /**
   * Get Order By Order Number
   * @param openIDToken The OpenID Token passed from Azure AD B2C
   * @param orderNumber Order Number
   * @param options The options parameters.
   */
  getOrderByOrderNumber(
    openIDToken: string,
    orderNumber: string,
    options?: GetOrderByOrderNumberOptionalParams
  ): Promise<GetOrderByOrderNumberResponse> {
    return this.sendOperationRequest(
      { openIDToken, orderNumber, options },
      getOrderByOrderNumberOperationSpec
    );
  }
}
// Operation Specifications
const serializer = coreClient.createSerializer(Mappers, /* isXml */ false);

const getOrderByOrderNumberOperationSpec: coreClient.OperationSpec = {
  path: "/order/V1/{orderNumber}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.Order
    },
    default: {
      bodyMapper: Mappers.ApiError
    }
  },
  urlParameters: [Parameters.$host, Parameters.orderNumber],
  headerParameters: [Parameters.accept, Parameters.openIDToken],
  serializer
};
